import "./HomePage.css";
import { Button, FormControl, TextField } from "@mui/material";
import { Http } from "../../utilities/Http";
import { StartingPoints } from "../../components/StartingPoints/StartingPoints";
import { useEffect, useReducer, useState } from "react";
import { StartingPoint } from "../../interfaces/StartingPoint.interface";
import { Rsvp } from "../../interfaces/Rsvp.interface";
import { RsvpForm } from "../../components/RsvpForm/RsvpForm";
import { Rsvps } from "../../components/Rsvps/Rsvps";
import { ApiRoutes } from "../../constants/apiRoutes";

interface HomePageProps {
  http: Http;
}

export const HomePage = ({ http }: HomePageProps) => {
  const [rsvpReloader, reloadRsvps] = useReducer((x) => x + 1, 0);

  const [rsvps, setRsvps] = useState<Rsvp[] | null>(null);
  const [startingPoints, setStartingPoints] = useState<StartingPoint[] | null>(
    null
  );

  useEffect(() => {
    const getStartingPoints = async () => {
      const startingPoints = await http.get<StartingPoint[]>(
        ApiRoutes.GetStartingPoints
      );
      setStartingPoints(startingPoints);
    };

    getStartingPoints();
  }, [http]);

  useEffect(() => {
    const getRsvps = async () => {
      const rsvps = await http.get<Rsvp[]>(ApiRoutes.GetRsvps);
      setRsvps(rsvps);
    };

    getRsvps();
  }, [http, rsvpReloader]);

  return (
    <div className="HomePage">
      <h1>Cindy's 28th Birthday Run!</h1>
      <div className="description">
        <p>
          Hi everyone! I'm celebrating turning 28 with a 28 mile run through
          NYC. I would love for you all to join me, even if only for a portion
          of the run. We are going to finish at my apartment where we can have
          pizza and snacks.
        </p>
        <p>
          Please sign up for where you would like to start the run! If you are
          completely running-averse, you can just meet me at the finish line to
          celebrate. Let me know if you have any questions! :)
        </p>
        <p>
          These are approximate times according calculated according to 9
          min/mile pace. I am more than happy to slow the pace as well when
          people join on! When everyone RSVPs, I will update the times to
          adjust.
        </p>
        <p>
          No need to bring gifts (unless you were planning to surprise me with a
          puppy and all of their expenses for their lifetime)! Instead, I would
          love it if you could run at least the last mile! It would mean a lot!
        </p>
        <p>Date: Nov. 19th, 2022</p>
        <div>
          <iframe
            className="map"
            src="https://www.google.com/maps/d/u/0/embed?mid=1ZTpVQuEvON_I9UY0ggbAEZwHCwzW7bo&ehbc=2E312F"
          ></iframe>
        </div>
      </div>

      {startingPoints && <StartingPoints startingPoints={startingPoints} />}
      {startingPoints && (
        <RsvpForm
          http={http}
          startingPoints={startingPoints}
          reloadRsvps={reloadRsvps}
        />
      )}
      {startingPoints && rsvps && (
        <Rsvps rsvps={rsvps} startingPoints={startingPoints} />
      )}
    </div>
  );
};
